/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Danger_DeletingInputs */

const zh_danger_deleting = /** @type {(inputs: Danger_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在删除...`)
};

const en_danger_deleting = /** @type {(inputs: Danger_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting...`)
};

const es_danger_deleting = /** @type {(inputs: Danger_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminando...`)
};

/**
* | output |
* | --- |
* | "Deleting..." |
*
* @param {Danger_DeletingInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const danger_deleting = /** @type {((inputs?: Danger_DeletingInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Danger_DeletingInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_danger_deleting(inputs)
	if (locale === "en") return en_danger_deleting(inputs)
	return es_danger_deleting(inputs)
});